//平台预收款常量定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 来源
 */
class UseType extends UltMeta {
    SHIP_WAYBILL = new Meta(1, "船运单");
    OIL_ORDER = new Meta(2, "油品订单");
}

export const USE_TYPE = new UseType();

class PlatBankAccountState extends UltMeta {
    DIASABLE = new Meta(0, "禁用");
    ENABLED = new Meta(1, "启用");
}

export const PLAT_BANK_ACCOUNT_STATE = new PlatBankAccountState();